import { Content } from '../../types';

export const chiangMaiMarketsContent: Content = {
  title: 'שווקים בצ׳אנג מאי',
  imageUrl: '/images/thailand/chiang-mai-markets/chiang-mai-markets-wide.jpeg',
  introduction: `צ'אנג מאי הינה גן עדן לחובבי שווקים, במיוחד שווקי לילה צבעוניים שמציעים אוכל רחוב משובח, מלאכת יד מקומית, בגדים, מזכרות ועוד. כאן תמצאו רשימה של השווקים המרכזיים בעיר, כולל טיפים שימושיים לביקור.`,
  sections: [
    {
      title: 'שווקי לילה מרכזיים בצ׳אנג מאי',
      type: 'sub-headers',
      description:
        'צ׳אנג מאי ידועה בשפע שווקי הלילה שלה, הנה רשימת השווקים המומלצים ביותר:',
      content: [
        {
          subtitle: 'שוק הלילה של צ׳אנג מאי (Chiang Mai Night Bazaar)',
          text: '<strong>מיקום:</strong> רחוב Chang Khlan, בין הרחובות Tha Phae ו-Sridonchai.\n<br /><strong>שעות פעילות:</strong> כל ערב משעות אחר הצהריים עד 23:00.\n<br /><strong>מה תמצאו שם?</strong> דוכנים רבים של בגדים, תיקים, תכשיטים, יצירות אמנות ומזכרות, לצד מתחמי אוכל מצוינים.\nטיפ: בסמוך לשוק נמצא Ploen Ruedee Night Market, מתחם אוכל מסודר עם מקומות ישיבה ולהקות מקומיות בהופעות חיות.',
        },
        {
          subtitle: 'שוק הסטודנטים (Chang Phuak Night Market)',
          text: '<strong>מיקום:</strong> רחוב Huay Kaew, מול שער אוניברסיטת צ׳אנג מאי.\n<br /><strong>שעות פעילות:</strong> כל ערב עד 23:00.\n<br /><strong>מה תמצאו שם?</strong> בגדים, אקססוריז, פריטי אופנה המיועדים בעיקר לצעירים ומתחם אוכל גדול.\nטיפ: בקרבת מקום נמצא קניון Maya, ובסמוך אליו מתחם הקניות והבילוי One Nimman, שניהם מומלצים לקניות ובילוי ערב.',
        },
        {
          subtitle: 'שוק Kad Kongkao',
          text: '<strong>מיקום:</strong> רחוב Ratvithi בעיר העתיקה.\n<br /><strong>שעות פעילות:</strong> ימי שישי בלבד, 16:00-23:00.\n<br /><strong>מה תמצאו שם?</strong> שוק אותנטי עם מזכרות, יצירות אמנות, אוכל מקומי ואווירה מסורתית.',
        },
        {
          subtitle: 'שוק Wua Lai (Saturday Night Market)',
          text: '<strong>מיקום:</strong> רחוב Wua Lai, סמוך לעיר העתיקה.\n<br /><strong>שעות פעילות:</strong> ימי שבת בלבד, 16:00-23:00.\n<br /><strong>מה תמצאו שם?</strong> מבחר גדול של בגדים, כלי בית, עבודות אמנות, מתחמי מסאז׳ ומתחמי אוכל מגוונים.',
        },
        {
          subtitle:
            'שוק Tha Phae (Sunday Night Market) - גולת הכותרת של שווקי הלילה בעיר!',
          text: '<strong>מיקום:</strong> רחוב Rachadamnoen, בין Tha Phae Gate לרחוב Samlarn.\n<br /><strong>שעות פעילות:</strong> ימי ראשון בלבד, 17:00-23:00.\n<br /><strong>מה תמצאו שם?</strong> נחשב לאחד משווקי הלילה המיוחדים והטובים בתאילנד! בגדים, תכשיטים, כלי בית, מזכרות ייחודיות לצפון תאילנד, מתחמי מסאז׳ ומוזיקה חיה.\nטיפ: השוק עמוס מאוד, כדאי להגיע מוקדם או מאוחר יותר כדי להימנע מההמונים.',
        },
      ],
    },
    {
      title: 'שווקי יום מעניינים בצ׳אנג מאי',
      type: 'sub-headers',
      description:
        'לצד שווקי הלילה המפורסמים, צ׳אנג מאי מציעה שווקי יום מרתקים שכדאי להכיר:',
      content: [
        {
          subtitle: 'שוק Warorot (Kad Luang Market)',
          text: '<strong>מיקום:</strong> סמוך לנהר הפינג.\n<br /><strong>שעות פעילות:</strong> כל יום, 06:00-18:00.\n<br /><strong>מה תמצאו שם?</strong> שוק מקומי עם אווירה מסורתית, מציע פירות, ירקות, תבלינים, מאכלים מקומיים ומוצרי טקסטיל מסורתיים של שבטי ההרים.',
        },
        {
          subtitle: 'שוק Ton Lamyai',
          text: '<strong>מיקום:</strong> ליד שוק Warorot.\n<br /><strong>שעות פעילות:</strong> כל יום, 06:00-18:00.\n<br /><strong>מה תמצאו שם?</strong> התמחות בפרחים טריים, כולל סידורי פרחים מרהיבים ומבחר רחב של סוגי פרחים אקזוטיים.',
        },
        {
          subtitle: 'שוק Muang Mai',
          text: '<strong>מיקום:</strong> צפונית לשוק Warorot.\n<br /><strong>שעות פעילות:</strong> כל יום, 04:00-18:00.\n<br /><strong>מה תמצאו שם?</strong> שוק סיטונאי שבו קונים המקומיים פירות, ירקות, עשבי תיבול ובשר טרי.\nטיפ: אם הינכם חובבי צילום - זהו מקום מצוין לתפוס תמונות אותנטיות מחיי היומיום בתאילנד.',
        },
        {
          subtitle: 'שוק Jing Jai Market',
          text: '<strong>מיקום:</strong> רחוב Atsadathorn, בצפון העיר.\n<br /><strong>שעות פעילות:</strong> שבת וראשון, 06:30-13:00.\n<br /><strong>מה תמצאו שם?</strong> שוק בוקר אקולוגי עם מוצרים אורגניים, אמנות בעבודת יד, בגדים, תכשיטים, קרמיקה, אוכל בריא וקפה איכותי.\nטיפ: כדאי להגיע מוקדם כדי ליהנות מהאווירה השלווה ולמצוא את המוצרים הטריים ביותר.',
        },
      ],
    },
    {
      title: 'טיפים כלליים לביקור בשווקים בצ׳אנג מאי',
      type: 'sub-headers',
      description:
        'כדי ליהנות באופן מיטבי מהביקור בשווקים, הנה כמה המלצות שימושיות:',
      content: [
        {
          subtitle: 'מיקוח והתנהלות',
          text: 'מיקוח הוא חלק מהחוויה - ברוב השווקים ניתן (וצריך) להתמקח, במיוחד בשוקי הלילה. מזומן הוא המלך - לא כל הדוכנים מקבלים כרטיסי אשראי, אז כדאי להצטייד בכסף מזומן.',
        },
        {
          subtitle: 'נוחות הטיול',
          text: 'ללבוש נעליים נוחות - השווקים גדולים ומצריכים הליכה ממושכת. להגיע מוקדם או מאוחר - כדי להימנע מהעומס, מומלץ להגיע בתחילת או בסוף שעות הפעילות.',
        },
        {
          subtitle: 'חוויות אוכל',
          text: 'לנסות את האוכל המקומי - במיוחד בשווקי הלילה, שם ניתן למצוא מנות צפון-תאילנדיות אותנטיות.',
        },
      ],
    },
    {
      title: 'בשורה התחתונה',
      content: `צ'אנג מאי מציעה מגוון עצום של שווקים, לכל סגנון ולכל שעה ביום. בין אם אתם מחפשים מזכרות ייחודיות, אוכל מקומי משובח או אווירה אותנטית - אין ספק שתמצאו זאת באחד מהשווקים הללו!`,
      type: 'text',
      isBold: true,
    },
  ],
};
